import React from "react";
import BaseModal from "./BaseModal";

const MediumModal = ({ titulo, subtitulo, isVisible, setVisible, children }) => {
  return (
    <BaseModal
      titulo={titulo}
      subtitulo={subtitulo}
      isVisible={isVisible}
      setVisible={setVisible}
      maxWidth="md"
      fullWidth
    >
      {children}
    </BaseModal>
  );
};

export default MediumModal;
